import { render, staticRenderFns } from "./DevelopersDoc.vue?vue&type=template&id=e5050420&scoped=true"
import script from "./DevelopersDoc.vue?vue&type=script&lang=js"
export * from "./DevelopersDoc.vue?vue&type=script&lang=js"
import style0 from "./DevelopersDoc.vue?vue&type=style&index=0&id=e5050420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5050420",
  null
  
)

export default component.exports